import { SeasonalEvent } from '../../types'

const seasonalEvents: Array<SeasonalEvent> = [
	{
		name: 'Salmonberry Season',
		date: {
			season: 1,
			day: 15
		},
		icon: 'Salmonberry.png'
	},
	{
		name: 'Salmonberry Season',
		date: {
			season: 1,
			day: 16
		},
		icon: 'Salmonberry.png'
	},
	{
		name: 'Salmonberry Season',
		date: {
			season: 1,
			day: 17
		},
		icon: 'Salmonberry.png'
	},
	{
		name: 'Salmonberry Season',
		date: {
			season: 1,
			day: 18
		},
		icon: 'Salmonberry.png'
	},
	{
		name: 'Extra Beach Foragables',
		date: {
			season: 2,
			day: 12
		},
		icon: 'RainbowShell.png'
	},
	{
		name: 'Extra Beach Foragables',
		date: {
			season: 2,
			day: 13
		},
		icon: 'RainbowShell.png'
	},
	{
		name: 'Extra Beach Foragables',
		date: {
			season: 2,
			day: 14
		},
		icon: 'RainbowShell.png'
	},
	{
		name: 'Blackberry Season',
		date: {
			season: 3,
			day: 8
		},
		icon: 'Blackberry.png'
	},
	{
		name: 'Blackberry Season',
		date: {
			season: 3,
			day: 9
		},
		icon: 'Blackberry.png'
	},
	{
		name: 'Blackberry Season',
		date: {
			season: 3,
			day: 10
		},
		icon: 'Blackberry.png'
	},
	{
		name: 'Blackberry Season',
		date: {
			season: 3,
			day: 11
		},
		icon: 'Blackberry.png'
	}
]

export default seasonalEvents